import Masonry from 'masonry-layout'

document.querySelectorAll('.element-photogallerygrid.as-masonry').forEach((el) => {
  const container = el.querySelector('.photo-grid')

  const grid = new Masonry(container, {
    itemSelector: '.photo-grid-item',
  })

  grid.layout()
})
